/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Done_Unavailable_CtaInputs */

const en_funnel_done_unavailable_cta = /** @type {(inputs: Funnel_Done_Unavailable_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See plans`)
};

const es_funnel_done_unavailable_cta = /** @type {(inputs: Funnel_Done_Unavailable_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver planes`)
};

/**
* | output |
* | --- |
* | "See plans" |
*
* @param {Funnel_Done_Unavailable_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_done_unavailable_cta = /** @type {((inputs?: Funnel_Done_Unavailable_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Done_Unavailable_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_done_unavailable_cta(inputs)
	return en_funnel_done_unavailable_cta(inputs)
});